import {ChangeDetectorRef, Component, Input, ViewEncapsulation} from '@angular/core';
import {UserId} from "../../types/ids";
import {UserService} from "../../services/user.service";

// @ts-ignore
import * as md5 from "md5";
import {AssetAndBlobService} from "../../services/assetAndBlob.service";
import {Subscription} from 'rxjs';
import {FeatureService} from '../../services/feature.service';
import {mergeMap} from 'rxjs/operators';

/**
 * Component showing the avatar image (currently relying on gravatar)
 */
@Component({
    selector: 'wm-avatar',
    template: `
        <div class="wm-m-avatar" [pTooltip]="(!noTooltip && usersName) ? usersName! : ''" [tooltipPosition]="tooltipPosition === undefined ? 'left' : tooltipPosition">
          @if (!useGravatar && usersAvatarURL.length === 0) {
            <img [style.width.px]="size" [style.height.px]="size" class="gravatar-img" data-testing-id="user-avatar" src="/assets/img/single_user_dark.svg">
          }
          @if (useGravatar && usersAvatarURL.length === 0) {
            <img [style.width.px]="size" [style.height.px]="size" class="gravatar-img" data-testing-id="user-avatar" onerror="this.src='/assets/img/single_user_dark.svg';" src="//www.gravatar.com/avatar/{{md5(usersEmail || '')}}?s={{size}}&d=mm">
          }
          @if (usersAvatarURL.length > 0) {
            <img [style.width.px]="size" [style.height.px]="size" class="own-avatar-img" data-testing-id="user-avatar" onerror="this.src='/assets/img/single_user_dark.svg';" [src]="usersAvatarURL">
          }
        </div>
        `,
    styleUrls: ['./avatar.component.less'],
    encapsulation: ViewEncapsulation.None
})
export class AvatarComponent {

    md5 = md5; // make available to template

    @Input() userId?: UserId;
    @Input() tooltipPosition: string;
    @Input() noTooltip: boolean = false;
    @Input() size: number = 32;
    @Input() webmateIcon: boolean = false;

    usersName?: string;
    usersEmail?: string;
    usersAvatarURL: string = ""; //might contain the path to a user-defined Asset

    useGravatar = false;

    private lastUserId?: UserId; //handling init without UserId
    private _userInfoSubscription?: Subscription; //we dispose subscriptions if we switch Users, hence we need a handle on that subscription

    constructor(private userService: UserService, private assetAndBlobService: AssetAndBlobService, private featureService: FeatureService, private cdRef: ChangeDetectorRef) {}

    private _cleanUserData(){
        this.usersName = "";
        this.usersEmail = "";
        this.usersAvatarURL = "";
        if (this._userInfoSubscription) {
            this._userInfoSubscription.unsubscribe();
        }
        this._userInfoSubscription = undefined;
    }

    ngOnChanges() {
        if (this.webmateIcon) {
            this._cleanUserData();
            this.usersName = "webmate";
            this.usersAvatarURL = "/assets/img/webmate_logo_icon_no_bg.svg";
            this.useGravatar = false;
        } else if (this.userId === undefined) {
            /** if there is NOW no user, delete any stored Data we have */
            this._cleanUserData();
        } else if (this.userId === '00000000-0000-0004-0000-000000000000') {
            this.usersName = "Unknown User";
            this.usersAvatarURL = "";
            this.usersEmail = "";
            this.useGravatar = false;
        } else {
            /** either there is a NEW User and we did not have one before OR we have CHANGED our User*/
            if (this.lastUserId !== this.userId) {
                /* we changed the User, so throw away previous data */
                this._cleanUserData();
                this.lastUserId = undefined;
            }
            if (this.lastUserId === undefined){
                /** subscribe to Data for the new User */
                this.lastUserId = this.userId;
                this._userInfoSubscription = this.featureService.getFeature("webmate.frontend.gravatar").pipe(mergeMap(f => {
                    this.useGravatar = !f || f.isActive;
                    return this.userService.getInformationAboutUser(this.userId)
                })).subscribe(info => {
                    this.usersAvatarURL = info.avatarId ? this.assetAndBlobService.obtainUrlToBlobData(info.avatarId) : "";
                    this.usersName = info.name;
                    this.usersEmail = info.email;
                    this.useGravatar = this.useGravatar && !!this.usersEmail;
                }, error => {
                    this.usersAvatarURL = "";
                    this.usersName = "Unknown User";
                    this.usersEmail = "";
                });
            }
        }
    }
}
